import type { ReactNode } from 'react';

import IntersectionReveal from '../intersection/IntersectionReveal';

type Props = {
  children: ReactNode;
  delay?: number;
  distance?: number;
  duration?: number;
  element?: 'li';
  ease?: string;
  mask?: boolean;
  once?: boolean;
};

export default function AniSlideUp({
  children,
  delay = 0,
  distance = 30,
  duration = 0.5,
  element,
  ease = 'power1.out',
  mask = false,
  once = true,
}: Props) {
  return (
    <IntersectionReveal
      delay={delay}
      duration={duration}
      element={element}
      ease={ease}
      hiddenTransform={`translate3d(0, ${distance}px, 0)`}
      mask={mask}
      once={once}
    >
      {children}
    </IntersectionReveal>
  );
}
